import _ from "lodash"

function keysToCamel(obj) {
  if (_.isArray(obj)) {
    return obj.map(keysToCamel)
  } else if (_.isPlainObject(obj)) {
    return _.mapValues(
      _.mapKeys(obj, (_v, k) => toCamelCase(k)),
      v => keysToCamel(v)
    )
  }
  return obj

  function toCamelCase(str) {
    if (!str || str.includes("-")) return str

    const parts = str.split("_")
    if (parts.length === 1) return str

    const first = parts.shift()
    const rest = parts.map(part =>
      part.charAt(0).toUpperCase() + part.slice(1)
    ).join("")
    return first + rest
  }
}

export default keysToCamel
